import { Spin } from "antd";
import { LoadingContainer, StyledCard, CustomIcon } from "./styles";

function LoadingCard() {
  return (
    <LoadingContainer>
      <StyledCard>
        <Spin
          size="large"
          indicator={<CustomIcon color="#009157" style={{ fontSize: 52 }} />}
        />
      </StyledCard>
    </LoadingContainer>
  );
}

export default LoadingCard;
